<template>
  <b-modal
    ref="editDataWidgetModal"
    hide-footer
    centered
    title="Create new data widget"
    size="lg"
    >
    <b-form @submit.prevent="save">
      <b-form-group
        label="Title:"
        >
        <b-form-input
          type="text"
          v-model.trim="widget.title"
          @keydown.ctrl.83.native.prevent="save"
          />
      </b-form-group>
      <b-form-group
        label="Data path:"
        >
        <b-form-input
          type="text"
          v-model.trim="widget.dataPath"
          @keydown.native.32.prevent
          @keydown.ctrl.83.native.prevent="save"
          ref="pathInput"
          />
      </b-form-group>
      <b-button
        variant="success"
        type="submit"
        >
        Save
      </b-button>
      <div class="dataWidget__treeView">
        <tree-view
          :data="widgetsData"
          :options="{
            maxDepth: 7,
            rootObjectKey: 'widgetsData'
          }"
          />
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
// helpers
import eventBus from '@/helpers/event-bus'
// services
import db from '@/services/db'

let $ = window.$

export default {
  props: ['widgetsData'],
  data () {
    return {
      widget: ''
    }
  },
  computed: {
    ...mapState([
      'currentTab'
    ])
  },
  methods: {
    save () {
      let key = this.widget['.key']
      delete this.widget['.key']
      db.widgets.update(key, this.widget, (err) => {
        if (err) this.$store.addError(err.message)
        else this.$refs.editDataWidgetModal.hide()
      })
    }
  },
  created () {
    eventBus.$on('showEditDataWidgetModal', (widget) => {
      this.widget = Object.assign({}, widget)
      if (this.$refs.editDataWidgetModal) this.$refs.editDataWidgetModal.show()
    })
  },
  mounted () {
    this.$nextTick(() => {
      $('.dataWidget__treeView .js-dataWidgetPathTrigger').remove()
      $(`
        .dataWidget__treeView .tree-view-item-leaf > .tree-view-item-key,
        .dataWidget__treeView .tree-view-item-node > .tree-view-item-key
      `)
        .prepend(`
          <span class="dataWidget__pathTrigger js-dataWidgetPathTrigger">
            <svg data-v-03b19cbe="" version="1.1" role="presentation" width="14.857142857142858" height="16" viewBox="0 0 1664 1792" class="fa-icon"><path d="M1456 1216q0-40-28-68l-208-208q-28-28-68-28-42 0-72 32 3 3 19 18.5t21.5 21.5 15 19 13 25.5 3.5 27.5q0 40-28 68t-68 28q-15 0-27.5-3.5t-25.5-13-19-15-21.5-21.5-18.5-19q-33 31-33 73 0 40 28 68l206 207q27 27 68 27 40 0 68-26l147-146q28-28 28-67zM753 511q0-40-28-68l-206-207q-28-28-68-28-39 0-68 27l-147 146q-28 28-28 67 0 40 28 68l208 208q27 27 68 27 42 0 72-31-3-3-19-18.5t-21.5-21.5-15-19-13-25.5-3.5-27.5q0-40 28-68t68-28q15 0 27.5 3.5t25.5 13 19 15 21.5 21.5 18.5 19q33-31 33-73zM1648 1216q0 120-85 203l-147 146q-83 83-203 83-121 0-204-85l-206-207q-83-83-83-203 0-123 88-209l-88-88q-86 88-208 88-120 0-204-84l-208-208q-84-84-84-204t85-203l147-146q83-83 203-83 121 0 204 85l206 207q83 83 83 203 0 123-88 209l88 88q86-88 208-88 120 0 204 84l208 208q84 84 84 204z"></path></svg>
          </span>
        `)

      this.$nextTick(() => {
        var vm = this

        $('.js-dataWidgetPathTrigger').on('click', function (event) {
          event.stopPropagation()
          let path = []
          $(this)
            .parentsUntil('.dataWidget__treeView .tree-view-item-leaf:first > .tree-view-item')
            .each((idx, item) => {
              if ($(item).find('> .tree-view-item-node').length) {
                let key = $(item).find('> .tree-view-item-node > .tree-view-item-key')
                path.push(key.text().trim().replace(/:|"/g, ''))
              }
            })
          let value = $(this).closest('.tree-view-item-leaf').find('> .tree-view-item-value')
          if (value.length) {
            let key = $(this).closest('.tree-view-item-key')
            path.unshift(key.text().trim().replace(/:|"/g, ''))
          }

          path = path.reverse()
          let input = vm.$refs.pathInput.$el

          vm.widget.dataPath = '/' + path.join('/')
          $(input).focus()

          if (!vm.$isInViewport(input)) {
            $($(input).closest('.modal')).animate({
              scrollTop: $(input).offset().top
            }, 500)
          }
        })
      })
    })

    if (this.$refs.editDataWidgetModal) {
      $(this.$refs.editDataWidgetModal['$el']).appendTo('body')
    }
  },
  beforeDestroy () {
    if (this.$refs.editDataWidgetModal) {
      $(this.$refs.editDataWidgetModal['$el']).remove()
    }
  }
}
</script>

<style lang="scss">
.tree-view-wrapper {
  padding-bottom: 5px;
}
.tree-view-item-leaf:hover > .tree-view-item-key .dataWidget__pathTrigger,
.tree-view-item-leaf > .tree-view-item-node:hover > .tree-view-item-key .dataWidget__pathTrigger {
  opacity: 1;
}
.tree-view-item-key {
  z-index: 1;
  position: relative;
}
.dataWidget {
  &__treeView {
    padding: {
      left: 20px;
      top: 20px;
    }
  }
  &__pathTrigger {
    z-index: 2;
    opacity: 0;
    position: absolute;
    left: -17px;
    top: 1px;
    width: 20px;
    cursor: pointer;
    &:hover {
      color: #79c1f8;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/EditDataWidget.vue